
















import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class IconPending extends Vue {
    @Prop({ type: Number, default: 15 }) readonly size!: number
}
